// frontend/src/services/DancerService.js
import axios from 'axios';

class DancerService {
  getAllDancers(sessionId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers`);
  }

  createDancer(sessionId, dancer) {
    return axios.post(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers`, dancer);
  }

  deleteDancer(sessionId, dancerId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers/${dancerId}`);
  }

  updateDancer(sessionId, dancerId, newName) {
    return axios.put(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers/${dancerId}?new_name=${encodeURIComponent(newName)}`
    );
  }

  associateSkill(sessionId, dancerId, skillId) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers/${dancerId}/skills/${skillId}`
    );
  }

  removeSkill(sessionId, dancerId, skillId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/dancers/${dancerId}/skills/${skillId}`
    );
  }
}

export default new DancerService();